module.exports = window.FormData;